<template>
  <div id="base">
    <div class="header" @click="closeAllDialog">
      <img src="../assets/image/logo.png" class="logo-pic" @click="offOrOn" />
      <div class="online"></div>
      <div class="username" @click="goDetail()">{{ usernameTop }}</div>

      <el-tooltip
        class="item"
        effect="light"
        content="退出登录"
        placement="bottom"
      >
        <i class="el-icon-third-tuichu loginout" @click="loginout()"></i>
      </el-tooltip>

      <span class="inform-view" @click.stop="openMsgBox">
        <span class="inform-ing" v-if="haveSocketMsgFlag"></span>
      </span>

      <el-tooltip
        class="item"
        effect="light"
        content="帮助中心"
        placement="bottom"
      >
        <i @click.stop="openHelpBox" class="el-icon-question help-center"></i>
      </el-tooltip>

      <!-- 消息盒子 -->
      <div class="message-box" v-if="messageShowFlag" @click.stop="solveMaopao">
        <div class="message-box-top">
          通 知
          <i class="el-icon-close close-icon" @click="closeMsgBox"></i>
        </div>
        <div class="message-box-list">
          <div
            v-for="(item, index) in messageList"
            :key="index"
            class="message-box-list-item"
          >
            <div class="msglist-img" v-if="item.level == 2">
              <img src="../assets/image/warning.png" />
            </div>
            <div class="msglist-img" v-if="item.level == 1">
              <img src="../assets/image/warning2.png" />
            </div>
            <div
              :class="
                item.msg_status == 0 ? 'msglist-title' : 'msglist-title-readed'
              "
              @click.stop="
                openWatchMsgBox(
                  item.title,
                  index,
                  item.id,
                  item.create_time,
                  item.sys_relation_id
                )
              "
            >
              {{ item.title }}
            </div>
            <div class="msglist-time">{{ item.create_time | formatTime }}</div>
          </div>
          <div
            class="read-more"
            v-if="readMoreShowFlag"
            @click.stop="getMoreMessagelist"
            v-loading="readMoreLoadFlag"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255,255,255,1)"
          >
            查看更多>>
          </div>
          <div v-if="noMoreMsgFlag" class="no-more-msg">没有更多消息了~~</div>
        </div>
        <div class="message-box-bottom">
          <div class="message-box-sendmsg" @click.stop="openSendMsgBox">
            发消息
          </div>
          <div
            @click.stop="setAllMsgSomeOperation('delete')"
            class="message-box-deletemsg"
          >
            全部删除
          </div>
          <div
            @click.stop="setAllMsgSomeOperation('markreaded')"
            class="mark-readed"
          >
            全部标为已读
          </div>
          <div class="message-box-close" @click.stop="closeMsgBox">关闭</div>
        </div>
      </div>

      <!-- 发消息弹框 -->
      <div
        class="send-message-box"
        v-if="sendMsgBoxShowFlag"
        @click.stop="solveMaopao"
      >
        <div class="close" @click.stop="closeSendMsgBox"></div>
        <div class="send-msg-item">
          <div class="send-msg-des">消息类型：</div>
          <el-select
            class="send-msg-option"
            v-model="sendMsgType"
            @change="getSendUserInfo"
            placeholder="请选择消息类型"
            size="small"
          >
            <el-option
              v-for="item in sendMsgTypeArr"
              :key="item.value"
              :label="item.content"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="send-msg-item">
          <div class="send-msg-des">消息等级：</div>
          <el-select
            class="send-msg-option"
            v-model="sendMsgLevel"
            placeholder="请选择消息等级"
            size="small"
          >
            <el-option
              v-for="item in sendMsgLevelArr"
              :key="item.value"
              :label="item.content"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="select-module">
          <div class="select-des">收信对象：<i>（请先选择好消息类型）</i></div>
          <el-select
            v-model="sendUserType"
            filterable
            v-if="receiveObjFlag1"
            clearable
            @change="getSendUserIdArr"
            placeholder="请选择对象类型"
            class="select-item"
            size="small"
          >
            <el-option
              v-for="item in sendUserTypeList"
              :key="item.value"
              :label="item.content"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="sendUserId"
            filterable
            clearable
            v-if="receiveObjFlag3"
            placeholder="请选择对象"
            class="select-item"
            size="small"
          >
            <el-option
              v-for="item in sendUserIdArr"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="send-msg-item">
          <div class="send-msg-des">消息标题：</div>
          <el-input
            class="send-msg-option"
            v-model="sendMsgTitle"
            placeholder="请输入消息的标题"
            size="small"
            clearable
          >
          </el-input>
        </div>
        <div class="send-content-des">消息内容：</div>
        <el-input
          placeholder="请输入要发送的内容"
          v-model="sendMsgContent"
          class="send-content"
          resize="none"
          type="textarea"
          :rows="3"
        ></el-input>
        <el-button
          class="send-msg-btn"
          type="primary"
          size="small"
          @click="sendMessage"
          >发 送</el-button
        >
      </div>

      <!-- 查看消息弹框 -->
      <div
        class="watch-message-box"
        v-if="watchMsgBoxShowFlag"
        @click.stop="solveMaopao"
      >
        <div class="close" @click.stop="closeWatchMsgBox"></div>
        <div class="send-msg-title">{{ selectSendTitle }}</div>
        <div class="send-user">
          发信人：<i>{{ selectSendUser }}</i>
        </div>
        <div class="send-time">
          发信时间：<i>{{ selectCreatTime }}</i>
        </div>
        <div class="send-msg-view">
          <div class="send-msg-des">消息内容：</div>
          <div class="send-msg-content">{{ selectSendMsg }}</div>
        </div>
        <div class="operate-view">
          <el-button
            class="delete-btn"
            type="danger"
            plain
            size="small"
            @click="deleteMsg"
            >删除</el-button
          >
        </div>
      </div>

      <!-- 帮助中心列表 -->
      <div
        class="help-center-box"
        v-if="helpDocumentFlag"
        @click.stop="solveMaopao"
      >
        <div class="help-title">
          帮助文档
          <i class="el-icon-close close-icon" @click.stop="closeHelpBox"></i>
        </div>
        <div
          v-for="(item, index) in helpDocumentList"
          :key="index"
          class="help-center-item"
        >
          <a target="_blank" :href="url + '/doc/' + item + '.pdf'">{{
            item
          }}</a>
        </div>
        <div class="version-view">云平台版本：{{ systemVersion }}</div>
      </div>
    </div>
    <div
      class="left-side"
      :style="{ width: widthData }"
      @click="closeAllDialog"
    >
      <!-- 功能选项 -->
      <el-menu
        :default-active="defaultactive"
        unique-opened
        router
        class="el-menu-vertical-demo"
        background-color="#545c64"
        text-color="#F8F8F9"
        :collapse="isCollapse"
        @select="handleSelect"
      >
        <el-submenu index="1" class="ii" v-if="adminFlag">
          <template slot="title">
            <i class="el-icon-third-guanliyuanguanli"></i>
            <span v-pre>管理员管理</span>
          </template>
          <el-menu-item index="AdminUserManage">用户管理</el-menu-item>
          <el-menu-item index="AdminTeamManage">群组管理</el-menu-item>
          <el-menu-item index="AdminRoleManage">角色管理</el-menu-item>
          <el-menu-item index="AuthList">权限管理</el-menu-item>
          <el-menu-item index="auditLog">审计日志</el-menu-item>
        </el-submenu>
        <el-submenu index="1" class="ii" v-if="!adminFlag">
          <template slot="title">
            <i class="el-icon-third-tenantuser"></i>
            <span>个人中心</span>
          </template>
          <el-menu-item index="CommonPersonalInfo">我的资料</el-menu-item>
        </el-submenu>
        <el-submenu index="2" v-show="productFlag || adminFlag" class="ii">
          <template slot="title">
            <i class="el-icon-third-chanpin"></i>
            <span>产品线和项目管理</span>
          </template>
          <el-menu-item
            index="CreateProject"
            v-show="addProjectFlag || adminFlag"
            >新增项目</el-menu-item
          >
          <el-menu-item
            index="ProjectList"
            v-show="profuctListFlag || adminFlag"
            >产品线列表</el-menu-item
          >
          <el-menu-item index="hierarchy" v-show="hierarchyFlag || adminFlag"
            >层级管理</el-menu-item
          >
        </el-submenu>
        <el-submenu index="3" v-show="softFlag || adminFlag" class="ii">
          <template slot="title">
            <i class="el-icon-third-icapp48px"></i>
            <span>软件管理</span>
          </template>
          <el-menu-item index="UploadFile" v-show="uploadSoftFlag || adminFlag"
            >上传软件</el-menu-item
          >
          <el-menu-item index="PackSoftware" v-show="packFileFlag || adminFlag"
            >打包软件</el-menu-item
          >
          <el-menu-item index="SoftwareList" v-show="softListFlag || adminFlag"
            >软件列表</el-menu-item
          >
          <el-menu-item
            index="productionProcessEditor"
            v-show="productionProcessEditorFlag || adminFlag"
            >生产流程编辑</el-menu-item
          >
        </el-submenu>
        <el-submenu index="4" v-show="orderFlag || adminFlag" class="ii">
          <template slot="title">
            <i class="el-icon-third-dingdan"></i>
            <span>订单管理</span>
          </template>
          <el-menu-item
            index="CreateOrderList"
            v-show="createOrderFlag || adminFlag"
            >创建订单</el-menu-item
          >
          <el-menu-item index="OrderList" v-show="orderListFlag || adminFlag"
            >订单列表</el-menu-item
          >
          <el-menu-item
            index="orderTracking"
            v-show="orderTrackingFlag || adminFlag"
            >订单追踪</el-menu-item
          >
          <el-menu-item
            index="qualityOrder"
            v-show="qualityOrderFlag || adminFlag"
            >品质订单</el-menu-item
          >
        </el-submenu>
        <el-submenu index="5" v-show="sampleFlag || adminFlag" class="ii">
          <template slot="title">
            <i class="el-icon-third-yangpinguanli"></i>
            <span>样品管理</span>
          </template>
          <el-menu-item index="SampleList" v-show="sampleListFlag || adminFlag"
            >样品列表</el-menu-item
          >
          <el-menu-item index="RejectsList" v-show="rejectListFlag || adminFlag"
            >不良品列表</el-menu-item
          >
        </el-submenu>
        <el-submenu index="6" class="ii" v-show="toolFlag || adminFlag">
          <template slot="title">
            <i class="el-icon-third-gongjuguanli"></i>
            <span>工具管理</span>
          </template>
          <el-menu-item
            index="TestingJigList"
            v-show="testingjigListFlag || adminFlag"
            >测试架列表</el-menu-item
          >
          <el-menu-item index="UKeyManage" v-show="ukeyListFlag || adminFlag"
            >UKey列表</el-menu-item
          >
          <el-menu-item
            index="Instrumentmanagement"
            v-show="InstrumentmanagementFlag || adminFlag"
            >资产管理</el-menu-item
          >
        </el-submenu>
        <el-submenu index="7" v-show="productionFlag || adminFlag" class="ii">
          <template slot="title">
            <i class="el-icon-third-shengchanguanli"></i>
            <span>生产管理</span>
          </template>
          <el-menu-item
            index="7-1"
            @click="openUrl('test')"
            v-show="searchTestRecordFlag || adminFlag"
          >
            测试记录查询
          </el-menu-item>
          <el-menu-item
            index="plantManagement"
            v-show="plantManagementFlag || adminFlag"
            >工厂管理</el-menu-item
          >
          <el-menu-item
            index="machineList"
            v-show="machineListFlag || adminFlag"
            >机台管理</el-menu-item
          >
          <el-menu-item
            index="deviceManagement"
            v-show="deviceManagement || adminFlag"
            >设备管理</el-menu-item
          >
          <el-menu-item
            index="machineCodeAuthorization"
            v-show="machineCodeAuthorizationFlag || adminFlag"
            >机器码授权</el-menu-item
          >
          <el-menu-item
            index="machineTypeManagement"
            v-show="machineTypeManagementFlag || adminFlag"
            >机台类型管理</el-menu-item
          >
          <el-menu-item
            index="logFileAnalysis"
            v-show="logFileAnalysisFlag || adminFlag"
            >日志文件分析</el-menu-item
          >
        </el-submenu>
        <el-submenu index="8" class="ii" v-show="testFlag || adminFlag">
          <template slot="title">
            <i class="el-icon-document-copy"></i>
            <span>日志管理系统</span>
          </template>
          <el-menu-item index="LogManage" v-show="LogManageFlag || adminFlag"
            >日志管理</el-menu-item
          >
          <el-menu-item index="ReportList" v-show="reportListFlag || adminFlag"
            >测试报告管理</el-menu-item
          >
        </el-submenu>
        <el-submenu index="9" class="ii" v-show="logFlag || adminFlag">
          <template slot="title">
            <i class="el-icon-tickets"></i>
            <span>日志导出</span>
          </template>
          <el-menu-item
            v-for="(url, index) in logUrlData"
            :key="index"
            :index="'9-' + index"
            @click="openUrl(url)"
          >
            {{ url.name }}
          </el-menu-item>
        </el-submenu>
        <el-menu-item
          index="10"
          v-show="kibanaFlag || adminFlag == true"
          @click="openUrl('bb')"
        >
          <i class="el-icon-third-icon-kibana-bb"></i>
          <span>Kibana</span>
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    if (this.url.indexOf("172.16.9.229") != -1) {
      this.url1 = "http://172.16.9.229:5443/";
    } else {
      this.url1 = this.url + ":5443/";
    }
    this.userid = window.localStorage.getItem("userid");
    this.token = window.localStorage.getItem("token");
    this.getUserInfo();
    this.getMenuList();
    this.getSystemVersion();
  },
  mounted() {
    var host = window.location.hostname;
    if (host == "localhost" || host == "127.0.0.1") {
      this.$emit("onOrOff", "isOn");
      this.widthData = "50px";
      this.isCollapse = true;
    } else {
      this.$emit("onOrOff", "isOff");
      this.widthData = "220px";
      this.isCollapse = false;
    }
  },
  data() {
    return {
      defaultactive: localStorage.defaultactive
        ? localStorage.defaultactive
        : "CommonPersonalInfo",
      widthData: "220px",
      isCollapse: false,
      adminFlag: "", //管理员标志
      url: this.url,
      url1: "",
      userid: "",
      token: "",
      addProjectFlag: false, //新增产品
      profuctListFlag: false, //产品列表
      hierarchyFlag: false, // 层级管理
      uploadSoftFlag: false, //上传软件
      softListFlag: false, //软件列表
      productionProcessEditorFlag: false, //生产流程编辑
      createOrderFlag: false, //创建订单
      relateToolFlag: false, //关联量产工具
      orderListFlag: false, //订单列表
      orderTrackingFlag: false, //订单追踪
      qualityOrderFlag: false, //品质订单
      sampleListFlag: false, //样品列表
      rejectListFlag: false, //不良品列表
      searchTestRecordFlag: false, //测试记录查询
      plantManagementFlag: false, //工厂管理
      machineListFlag: false, //机台管理
      deviceManagement: false, //设备管理
      machineCodeAuthorizationFlag: false, //机器码授权
      machineTypeManagementFlag: false, //机台类型管理
      testingjigListFlag: false, //测试架列表
      ukeyListFlag: false, //ukey列表
      InstrumentmanagementFlag: false, // 资产管理
      packFileFlag: false, //打包软件
      logFileAnalysisFlag: false, //日志文件分析
      kibanaFlag: false, //Kibana页面权限
      testFlag: false, // 日志管理系统
      reportListFlag: false, // 测试报告管理
      LogManageFlag: false, // 日志管理
      logFlag: false, // 日志提取
      sampleFlag: false,
      productFlag: false,
      productionFlag: false,
      toolFlag: false,
      softFlag: false,
      orderFlag: false,
      username: "",
      websock: null,
      messageShowFlag: false, //消息列表显示标志
      messageList: [], //消息列表
      page: 1, //获取消息列表页码
      number: 20, //消息列表每页个数
      haveSocketMsgFlag: false, //是否显示未读消息的红点点
      sendMsgBoxShowFlag: false, //用户发消息的弹框显示标志
      watchMsgBoxShowFlag: false, //用户查看具体消息弹框显示标志
      readMoreLoadFlag: false, //查看更多消息加载标志
      noMoreMsgFlag: false, //没有更多消息的标志
      sendMsgTitle: "", //发送消息标题
      sendMsgContent: "", //发送消息内容
      sendMsgType: "群发", //发送消息类型
      sendMsgTypeArr: [
        { value: "single", content: "单个用户" },
        { value: "broadcast", content: "群发" }
      ],
      sendMsgLevel: "一般", //发送消息等级
      sendMsgLevelArr: [
        { value: 0, content: "一般" },
        { value: 1, content: "紧急" },
        { value: 2, content: "非常紧急" }
      ],
      sendUserType: "", //发送消息对象类型
      sendUserTypeList: [],
      receiveObjFlag1: true,
      receiveObjFlag3: true,
      sendUserId: "", //发送消息对象id
      sendUserIdArr: [],
      readMoreShowFlag: false,
      selectSendUser: "", //查看发送消息的发信人
      selectCreatTime: "", //查看发送消息的发送时间
      selectSendMsg: "", //查看发送消息的发送信息
      selectSendTitle: "", //查看发送消息的发送标题
      deleteMsgIndex: "", //删除消息的索引
      deleteMsgId: "", //删除消息的id
      helpDocumentList: [], //帮助文档列表
      helpDocumentFlag: false,
      systemVersion: "",
      logUrlData: [], // 日志地址
      down: true //顶部收放标识
    };
  },
  computed: {
    usernameTop() {
      return this.$store.state.usernameTop;
    }
  },
  filters: {
    formatTime(e) {
      var time = new Date(parseInt(e) * 1000);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      return y + "-" + m + "-" + d;
    }
  },
  methods: {
    handleSelect(key) {
      if (
        key.indexOf("7") != -1 ||
        key.indexOf("9") != -1 ||
        key.indexOf("10") != -1
      )
        return;
      window.localStorage.setItem("defaultactive", key);
      this.defaultactive = key;
    },
    offOrOn() {
      if (this.widthData == "220px") {
        this.$emit("onOrOff", "isOn");
        this.widthData = "50px";
        this.isCollapse = true;
      } else {
        this.$emit("onOrOff", "isOff");
        this.widthData = "220px";
        this.isCollapse = false;
      }
    },
    solveMaopao() {
      // console.log(1)
    },
    closeAllDialog() {
      if (this.helpDocumentFlag == true || this.messageShowFlag == true) {
        this.helpDocumentFlag = false;
        this.messageShowFlag = false;
      }
    },
    getSendAllUserPermission() {
      //判断用户发消息是否有发送给全部用户的权限
      this.$http
        .get(
          this.url +
            "/api/v1/role/permission?userid=" +
            this.userid +
            "&token=" +
            this.token +
            "&optype=user&opid=" +
            this.userid +
            '&objtype=/notify&objid=[0]&actions=["POST_notify"]'
        )
        .then(res => {
          if (res.data.errcode == 0) {
            // console.log(res.data.data['POST_notify'][0].status)
            let permission = res.data.data["POST_notify"][0].status;
            if (permission == true) {
              this.sendUserTypeList = [
                { value: "all", content: "所有用户" },
                { value: "team", content: "群组" },
                { value: "product", content: "产品线" },
                { value: "module", content: "项目" }
              ];
            } else {
              this.sendUserTypeList = [
                { value: "team", content: "群组" },
                { value: "product", content: "产品线" },
                { value: "module", content: "项目" }
              ];
            }
          }
        })
        .catch(error => {
          console.error(error);
          this.sendUserTypeList = [
            { value: "team", content: "群组" },
            { value: "product", content: "产品线" },
            { value: "module", content: "项目" }
          ];
        });
    },
    getSystemVersion() {
      this.$http
        .get(this.url + "/api/v1/middleware/version")
        .then(res => {
          if (res.data.errcode == 0) {
            this.systemVersion = res.data.data;
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    goDetail() {
      let defaultactive = "";
      if (window.localStorage.getItem("admin") == "admin") {
        this.$router.push("/AdminInfo");
        defaultactive = "AdminInfo";
      } else if (window.localStorage.getItem("admin") == "user") {
        this.$router.push("/CommonPersonalInfo");
        defaultactive = "CommonPersonalInfo";
      }
      this.handleSelect(defaultactive);
    },
    getUserInfo() {
      //获取用户信息
      this.$http
        .get(
          this.url +
            "/api/v1/user/user?userid=" +
            this.userid +
            "&token=" +
            this.token +
            "&id=" +
            this.userid
        )
        .then(res => {
          // console.log(res.data);
          res = res.data;
          if (res.errcode == 0) {
            this.username =
              res.data.name == "" ? res.data.email : res.data.name;
            this.$store.state.usernameTop = this.username;
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    //获取用户可显示的菜单
    getMenuList() {
      this.$http
        .get(
          this.url +
            "/api/v1/middleware/user/permissions?userid=" +
            this.userid +
            "&token=" +
            this.token
        )
        .then(res => {
          res = res.data;
          if (res.errcode == 0 && res.errmsg == "ok") {
            if (res.data.admin == true) {
              this.adminFlag = true;
              this.getLogUrl();
            } else if (res.data.admin == false) {
              this.adminFlag = false;
              if (
                res.data.permissions != null &&
                res.data.permissions.length > 0
              ) {
                for (var k = 0; k < res.data.permissions.length; k++) {
                  if (
                    res.data.permissions[k].indexOf("新增项目") != -1 &&
                    res.data.permissions[k].indexOf("产品线列表") != -1 &&
                    res.data.permissions[k].indexOf("层级管理") != -1
                  ) {
                    this.productFlag = true;
                    this.addProjectFlag = true;
                    this.profuctListFlag = true;
                    this.hierarchyFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("新增项目") != -1) {
                    this.productFlag = true;
                    this.addProjectFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("产品线列表") != -1) {
                    this.productFlag = true;
                    this.profuctListFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("层级管理") != -1) {
                    this.productFlag = true;
                    this.hierarchyFlag = true;
                  }
                  if (
                    res.data.permissions[k].indexOf("上传软件") != -1 &&
                    res.data.permissions[k].indexOf("软件列表") != -1 &&
                    res.data.permissions[k].indexOf("打包软件") != -1
                  ) {
                    this.softFlag = true;
                    this.uploadSoftFlag = true;
                    this.softListFlag = true;
                    this.packFileFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("上传软件") != -1) {
                    this.softFlag = true;
                    this.uploadSoftFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("软件列表") != -1) {
                    this.softFlag = true;
                    this.softListFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("打包软件") != -1) {
                    this.softFlag = true;
                    this.packFileFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("生产流程编辑") != -1) {
                    this.softFlag = true;
                    this.productionProcessEditorFlag = true;
                  }
                  if (
                    res.data.permissions[k].indexOf("创建订单") != -1 &&
                    res.data.permissions[k].indexOf("订单列表") != -1
                  ) {
                    this.orderFlag = true;
                    this.createOrderFlag = true;
                    this.orderListFlag = true;
                    this.qualityOrderFlag = true;
                    this.orderTrackingFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("创建订单") != -1) {
                    this.orderFlag = true;
                    this.createOrderFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("订单列表") != -1) {
                    this.orderFlag = true;
                    this.orderListFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("订单追踪") != -1) {
                    this.orderFlag = true;
                    this.orderTrackingFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("品质订单") != -1) {
                    this.orderFlag = true;
                    this.qualityOrderFlag = true;
                  }
                  if (
                    res.data.permissions[k].indexOf("不良品列表") != -1 &&
                    res.data.permissions[k].indexOf("样品列表") != -1
                  ) {
                    this.sampleFlag = true;
                    this.rejectListFlag = true;
                    this.sampleListFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("样品列表") != -1) {
                    this.sampleFlag = true;
                    this.sampleListFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("不良品列表") != -1) {
                    this.sampleFlag = true;
                    this.rejectListFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("测试记录查询") != -1) {
                    this.productionFlag = true;
                    this.searchTestRecordFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("机台类型管理") != -1) {
                    this.productionFlag = true;
                    this.machineTypeManagementFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("机台管理") != -1) {
                    this.productionFlag = true;
                    this.machineListFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("设备管理") != -1) {
                    this.productionFlag = true;
                    this.deviceManagement = true;
                  }
                  if (res.data.permissions[k].indexOf("机器码授权") != -1) {
                    this.productionFlag = true;
                    this.machineCodeAuthorizationFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("工厂管理") != -1) {
                    this.productionFlag = true;
                    this.plantManagementFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("日志文件分析") != -1) {
                    this.productionFlag = true;
                    this.logFileAnalysisFlag = true;
                  }
                  if (
                    res.data.permissions[k].indexOf("测试架列表") != -1 &&
                    res.data.permissions[k].indexOf("UKey列表") != -1
                  ) {
                    this.toolFlag = true;
                    this.testingjigListFlag = true;
                    this.ukeyListFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("测试架列表") != -1) {
                    this.toolFlag = true;
                    this.testingjigListFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("UKey列表") != -1) {
                    this.toolFlag = true;
                    this.ukeyListFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("资产管理") != -1) {
                    this.toolFlag = true;
                    this.InstrumentmanagementFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("Kibana") != -1) {
                    this.kibanaFlag = true;
                  }
                  if (
                    res.data.permissions[k].indexOf("日志管理") != -1 &&
                    res.data.permissions[k].indexOf("测试报告管理") != -1
                  ) {
                    this.testFlag = true;
                    this.reportListFlag = true;
                    this.LogManageFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("日志管理") != -1) {
                    this.testFlag = true;
                    this.LogManageFlag = true;
                  }
                  if (res.data.permissions[k].indexOf("日志导出") != -1) {
                    this.logFlag = true;
                    this.getLogUrl();
                  }
                  if (res.data.permissions[k].indexOf("测试报告管理") != -1) {
                    this.testFlag = true;
                    this.reportListFlag = true;
                  }
                }
              }
            }
            this.helpDocumentList = res.data.doc;
            this.initWebSocket(this.userid, this.token);
          } else {
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    // 获取跳转日志地址
    getLogUrl() {
      this.$http
        .get(this.url + "/api/v1/middleware/etcdkey?key=logserver")
        .then(res => {
          if (res.data.errcode == 0) {
            for (let i in res.data.data) {
              this.logUrlData.push({
                name: i,
                url:
                  res.data.data[i] +
                  "?user=" +
                  this.userid +
                  "&token=" +
                  this.token
              });
            }
          }
        })
        .catch(error => {
          this.error0(error);
        });
    },
    // 跳转日志
    openUrl(e) {
      let url =
        e === "test"
          ? "http://10.2.3.87:480/#/Main?userid=" +
            this.userid +
            "&token=" +
            this.token
          : e === "bb"
          ? this.url1
          : e.url;
      window.open(url);
    },
    loginout() {
      //退出登录
      this.websock.onopen = this.websocketonopen("closed");
      window.localStorage.removeItem("userid");
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("admin");
      window.localStorage.removeItem("pname");
      window.localStorage.removeItem("pid");
      this.$router.push("/Login");
    },
    initWebSocket(id, token) {
      //初始化websocket
      let host = window.location.host;
      let origin = "";
      if (host == "localhost:8080") {
        host = "172.16.9.229:80";
      }
      if (window.location.protocol == "http:") {
        origin = "ws";
      } else {
        origin = "wss";
      }
      const wsuri =
        origin +
        "://" +
        host +
        "/api/v1/notify/ws/message?userid=" +
        id +
        "&token=" +
        token;
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      // this.websock.onclose = this.websocketclose;
    },
    websocketonmessage(e) {
      //websocket数据接收
      this.haveSocketMsgFlag = true;
      const redata = JSON.parse(e.data);
      let _this = this;
      let obj = {
        id: redata.id,
        title: redata.title,
        level: redata.level,
        sys_relation_id: redata.sys_relation_id,
        create_time: redata.create_time,
        msg_status: 0
      };
      _this.messageList.unshift(obj);
      this.$notify({
        title: "您有新消息了！",
        message: redata.title,
        position: "top-right",
        offset: 100,
        onClick: function() {
          // console.log(redata)
          _this.watchMsgBoxShowFlag = true;
          _this.$http
            .get(
              this.url +
                "/api/v1/notify/get/content/message?userid=" +
                _this.userid +
                "&token=" +
                _this.token +
                "&msg_id=" +
                redata.id
            )
            .then(res => {
              if (res.data.errcode == 0) {
                let date = new Date(parseInt(redata.create_time) * 1000);
                let y = date.getFullYear();
                let m = date.getMonth() + 1;
                let d = date.getDate();
                let h = date.getHours();
                let mi = date.getMinutes();
                let s = date.getSeconds();
                _this.selectCreatTime =
                  y + "-" + m + "-" + d + " " + h + ":" + mi + ":" + s;
                _this.deleteMsgId = redata.sys_relation_id;
                _this.selectSendUser = redata.sender_user_uame;
                _this.selectSendMsg = res.data.data.message;
                _this.deleteMsgIndex = 0;
              }
            })
            .catch(error => {
              console.error(error);
            });
        }
      });
    },
    websocketonopen(data) {
      // let actions = 'closed';
      this.websocketsend(data);
    },
    websocketonerror() {
      var that = this;
      that.initWebSocket(that.id, that.token);
    },
    websocketclose(e) {
      //关闭
      console.log("断开连接", e);
    },
    websocketsend(data) {
      this.websock.send(data);
    },
    closeMsgBox() {
      //关闭消息列表盒子
      this.messageShowFlag = false;
      this.messageList = [];
    },
    openMsgBox() {
      //打开消息列表盒子
      this.helpDocumentFlag = false;
      this.messageShowFlag = !this.messageShowFlag;
      if (this.messageShowFlag == true) {
        this.haveSocketMsgFlag = false;
        this.readMoreLoadFlag = false;
        this.getMessageList();
      } else {
        this.messageList = [];
      }
    },
    getMessageList() {
      //获取消息列表
      this.page = 1;
      this.messageList = [];
      this.noMoreMsgFlag = false;
      this.$http
        .get(
          this.url +
            "/api/v1/notify/get/intro/message?userid=" +
            this.userid +
            "&token=" +
            this.token +
            "&page=" +
            this.page +
            "&size=" +
            this.number
        )
        .then(res => {
          if (res.data.errcode == 0) {
            if (res.data.data != null && res.data.data.length > 0) {
              if (res.data.data.length >= this.number) {
                this.readMoreShowFlag = true;
              }
              this.messageList = res.data.data;
            } else {
              this.noMoreMsgFlag = true;
            }
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    getMoreMessagelist() {
      //获取更多
      if (this.readMoreLoadFlag == true) {
        return;
      }
      this.readMoreLoadFlag = true;
      this.noMoreMsgFlag = false;
      this.page = this.page + 1;
      this.$http
        .get(
          this.url +
            "/api/v1/notify/get/intro/message?userid=" +
            this.userid +
            "&token=" +
            this.token +
            "&page=" +
            this.page +
            "&size=" +
            this.number
        )
        .then(res => {
          if (res.data.errcode == 0) {
            if (res.data.data != null && res.data.data.length > 0) {
              let tempMessageList = [];
              if (res.data.data.length >= this.number) {
                this.readMoreShowFlag = true;
              }
              tempMessageList = res.data.data;
              this.messageList = this.messageList.concat(tempMessageList);
              this.readMoreLoadFlag = false;
            } else {
              this.readMoreLoadFlag = false;
              this.readMoreShowFlag = false;
              this.noMoreMsgFlag = true;
            }
          } else {
            this.readMoreLoadFlag = false;
            this.readMoreShowFlag = false;
            this.noMoreMsgFlag = true;
          }
        })
        .catch(error => {
          this.readMoreLoadFlag = false;
          this.readMoreShowFlag = false;
          this.noMoreMsgFlag = true;
          console.error(error);
        });
    },
    openSendMsgBox() {
      //打开发消息的盒子
      this.sendMsgBoxShowFlag = true;
      this.getSendAllUserPermission();
    },
    closeSendMsgBox() {
      //关闭发消息的盒子
      this.sendMsgBoxShowFlag = false;
      this.sendMsgType = "群发";
      this.sendMsgLevel = "一般";
      this.receiveObjFlag1 = true;
      this.receiveObjFlag3 = true;
      this.sendUserType = "";
      this.sendUserTypeList = [];
      this.sendUserId = "";
      this.sendUserIdArr = [];
      this.sendMsgTitle = "";
      this.sendMsgContent = "";
    },
    openWatchMsgBox(title, index, id, time, deleteId) {
      //打开查看消息的盒子
      this.deleteMsgIndex = index;
      this.deleteMsgId = deleteId;
      this.selectSendTitle = title;
      this.watchMsgBoxShowFlag = true;
      this.$http
        .get(
          this.url +
            "/api/v1/notify/get/content/message?userid=" +
            this.userid +
            "&token=" +
            this.token +
            "&msg_id=" +
            id
        )
        .then(res => {
          if (res.data.errcode == 0) {
            let date = new Date(parseInt(time) * 1000);
            let y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            let h = date.getHours();
            let mi = date.getMinutes();
            let s = date.getSeconds();
            this.selectCreatTime =
              y + "-" + m + "-" + d + " " + h + ":" + mi + ":" + s;
            this.selectSendUser = res.data.data.sender_user_uame;
            this.selectSendMsg = res.data.data.message;
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    closeWatchMsgBox() {
      //关闭查看消息的盒子
      if (this.deleteMsgIndex != 0 && this.deleteMsgIndex != "") {
        this.messageList[this.deleteMsgIndex].msg_status = 1;
        this.deleteMsgIndex = "";
      } else if (this.deleteMsgIndex == 0) {
        this.messageList[0].msg_status = 1;
        this.deleteMsgIndex = "";
      }
      this.watchMsgBoxShowFlag = false;
      this.selectSendUser = "";
      this.selectCreatTime = "";
      this.selectSendMsg = "";
      this.deleteMsgId = "";
    },
    deleteMsg() {
      //删除消息
      this.$confirm("此操作将永久删除该消息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let parmas = JSON.stringify({
            userid: this.userid,
            token: this.token,
            id_list: [this.deleteMsgId]
          });
          this.$http
            .delete(
              this.url +
                "/api/v1/notify/delete/message?userid=" +
                this.userid +
                "&token=" +
                this.token,
              { data: parmas }
            )
            .then(res => {
              if (res.data.errcode == 0) {
                this.messageList.splice(this.deleteMsgIndex, 1);
                this.watchMsgBoxShowFlag = false;
                this.selectSendUser = "";
                this.selectCreatTime = "";
                this.selectSendMsg = "";
                this.deleteMsgId = "";
                this.deleteMsgIndex = "";
                this.$message({
                  showClose: true,
                  message: "删除成功！",
                  type: "success"
                });
              } else {
                this.$message({
                  showClose: true,
                  message: "删除失败！",
                  type: "error"
                });
              }
            })
            .catch(error => {
              console.error(error);
              this.$message({
                showClose: true,
                message: "删除失败！",
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    getSendUserList() {
      //获取可看到的用户列表
      this.sendUserIdArr = [];
      this.$http
        .get(
          this.url +
            "/api/v1/user/users?userid=" +
            this.userid +
            "&token=" +
            this.token
        )
        .then(res => {
          if (res.data.errcode == 0) {
            if (res.data.data != null && res.data.data.length > 0) {
              let tempSendUserIdArr = [];
              for (let i = 0; i < res.data.data.length; i++) {
                let parmas = {
                  id: res.data.data[i].userid,
                  value:
                    res.data.data[i].name != ""
                      ? res.data.data[i].name
                      : res.data.data[i].email
                };
                tempSendUserIdArr.push(parmas);
              }
              this.sendUserIdArr = tempSendUserIdArr;
            }
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    getProductList() {
      //获取产品线列表
      this.sendUserIdArr = [];
      this.$http
        .get(
          this.url +
            "/api/v1/product/products?userid=" +
            this.userid +
            "&token=" +
            this.token
        )
        .then(res => {
          if (res.data.errcode == 0) {
            if (res.data.data != null && res.data.data.length > 0) {
              let tempProductList = [];
              for (let i = 0; i < res.data.data.length; i++) {
                let parmas = {
                  id: res.data.data[i].id,
                  value: res.data.data[i].name
                };
                tempProductList.push(parmas);
              }
              this.sendUserIdArr = tempProductList;
            }
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    getTeamList() {
      //获取群组列表
      this.sendUserIdArr = [];
      this.$http
        .get(
          this.url +
            "/api/v1/team/teams?userid=" +
            this.userid +
            "&token=" +
            this.token
        )
        .then(res => {
          if (res.data.errcode == 0) {
            if (res.data.data != null && res.data.data.length > 0) {
              let tempTeamList = [];
              for (let i = 0; i < res.data.data.length; i++) {
                let parmas = {
                  id: res.data.data[i].id,
                  value: res.data.data[i].name
                };
                tempTeamList.push(parmas);
              }
              this.sendUserIdArr = tempTeamList;
            }
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    getModuleList() {
      //获取项目列表
      this.sendUserIdArr = [];
      this.$http
        .get(
          this.url +
            "/api/v1/module/modules?userid=" +
            this.userid +
            "&token=" +
            this.token
        )
        .then(res => {
          if (res.data.errcode == 0) {
            if (res.data.data != null && res.data.data.length > 0) {
              let tempModuleList = [];
              // console.log(res.data.data)
              for (let i = 0; i < res.data.data.length; i++) {
                let parmas = {
                  id: res.data.data[i].id,
                  value: res.data.data[i].name
                };
                tempModuleList.push(parmas);
              }
              this.sendUserIdArr = tempModuleList;
            }
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    sendMessage() {
      //发送信息
      if (this.sendMsgType == "群发") {
        this.sendMsgType = "broadcast";
      }
      if (this.sendMsgLevel == "一般") {
        this.sendMsgLevel = 0;
      }
      if (this.sendMsgType == "") {
        this.$message({
          showClose: true,
          message: "请先选择消息类型！",
          type: "warning"
        });
        return;
      }
      if (this.sendMsgType == "single" && this.sendUserId == "") {
        this.$message({
          showClose: true,
          message: "请先选择收信人！",
          type: "warning"
        });
        return;
      }
      if (this.sendMsgType == "broadcast" && this.sendUserType == "") {
        this.$message({
          showClose: true,
          message: "请先选择收信对象类型！",
          type: "warning"
        });
        return;
      }
      if (
        this.sendMsgType == "broadcast" &&
        this.sendUserType != "all" &&
        this.sendUserId == ""
      ) {
        this.$message({
          showClose: true,
          message: "请先选择具体收信对象！",
          type: "warning"
        });
        return;
      }
      if (this.sendMsgTitle == "") {
        this.$message({
          showClose: true,
          message: "请先填写消息标题！",
          type: "warning"
        });
        return;
      }
      if (this.sendMsgContent == "") {
        this.$message({
          showClose: true,
          message: "请先填写消息内容！",
          type: "warning"
        });
        return;
      }
      let parmas = JSON.stringify({
        userid: this.userid,
        token: this.token,
        broadcast_obj: this.sendMsgType == "single" ? "" : this.sendUserType,
        broadcast_id:
          this.sendMsgType == "single" || this.sendUserType == "all"
            ? 0
            : this.sendUserId,
        msg_type: this.sendMsgType,
        msg_level: this.sendMsgLevel,
        be_send_user: this.sendMsgType == "single" ? this.sendUserId : 0,
        title: this.sendMsgTitle,
        content: this.sendMsgContent,
        sender_user_uame: this.$store.state.usernameTop
      });
      this.$http
        .post(
          this.url +
            "/api/v1/notify/push/message?userid=" +
            this.userid +
            "&token=" +
            this.token,
          parmas,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          if (res.data.errcode == 0) {
            this.$message({
              showClose: true,
              message: "发送成功！",
              type: "success"
            });
            this.closeSendMsgBox();
          } else {
            this.$message({
              showClose: true,
              message: "发送失败！",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.error(error);
          this.$message({
            showClose: true,
            message: "发送失败！",
            type: "error"
          });
        });
    },
    getSendUserInfo() {
      //获取收件对象类型数组
      this.sendUserType = "";
      this.sendUserTypeList = [];
      this.sendUserIdArr = [];
      this.sendUserId = "";
      if (this.sendMsgType == "single") {
        this.receiveObjFlag1 = false;
        this.getSendUserList();
      } else if (this.sendMsgType == "broadcast") {
        this.receiveObjFlag1 = true;
        this.getSendAllUserPermission();
      }
    },
    getSendUserIdArr() {
      //获取收件对象的数组
      // console.log(this.sendUserType)
      this.sendUserIdArr = [];
      this.sendUserId = "";
      if (this.sendUserType == "all") {
        this.receiveObjFlag3 = false;
      } else if (this.sendUserType == "team") {
        this.receiveObjFlag3 = true;
        this.getTeamList();
      } else if (this.sendUserType == "product") {
        this.receiveObjFlag3 = true;
        this.getProductList();
      } else if (this.sendUserType == "module") {
        this.receiveObjFlag3 = true;
        this.getModuleList();
      }
    },
    setAllMsgSomeOperation(type) {
      //给所有消息进行具体操作
      if (this.messageList.length == 0) {
        this.$message({
          showClose: true,
          message: "暂无任何消息通知！",
          type: "warning"
        });
        return;
      }
      if (type == "delete") {
        this.$confirm("确定要删除全部文件吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.$http
              .delete(
                this.url +
                  "/api/v1/notify/delete/all/message?userid=" +
                  this.userid +
                  "&token=" +
                  this.token
              )
              .then(res => {
                if (res.data.errcode == 0) {
                  this.$message({
                    showClose: true,
                    message: "删除成功！",
                    type: "success"
                  });
                  this.getMessageList();
                } else {
                  this.$message({
                    showClose: true,
                    message: "删除失败！",
                    type: "error"
                  });
                }
              })
              .catch(error => {
                console.error(error);
                this.$message({
                  showClose: true,
                  message: "删除失败！",
                  type: "error"
                });
              });
          })
          .catch(() => {});
      } else if (type == "markreaded") {
        this.$confirm("确定要全部标为已读吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.$http
              .post(
                this.url +
                  "/api/v1/notify/set/read/message?userid=" +
                  this.userid +
                  "&token=" +
                  this.token
              )
              .then(res => {
                if (res.data.errcode == 0) {
                  this.$message({
                    showClose: true,
                    message: "标记成功！",
                    type: "success"
                  });
                  this.getMessageList();
                } else {
                  this.$message({
                    showClose: true,
                    message: "标记失败！",
                    type: "error"
                  });
                }
              })
              .catch(error => {
                console.error(error);
                this.$message({
                  showClose: true,
                  message: "标记失败！",
                  type: "error"
                });
              });
          })
          .catch(() => {});
      }
    },
    openHelpBox() {
      //打开文档中心弹框
      this.helpDocumentFlag = !this.helpDocumentFlag;
      this.messageShowFlag = false;
    },
    closeHelpBox() {
      //关闭文档中心弹框
      this.helpDocumentFlag = false;
    }
  }
};
</script>

<style lang="scss">
#base {
  .header {
    background-color: #222;
    width: 100%;
    height: 60px;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    .logo-pic {
      position: absolute;
      width: 299px;
      top: 16px;
      left: 20px;
    }
    .online {
      color: aquamarine;
      position: absolute;
      display: inline-block;
      font-size: 14px;
      right: 100px;
      height: 60px;
      line-height: 60px;
      top: 0;
    }
    .username {
      position: absolute;
      display: inline-block;
      color: #fff;
      font-size: 16px;
      right: 200px;
      height: 60px;
      line-height: 60px;
      top: 0px;
      cursor: pointer;
    }
    .loginout {
      position: absolute;
      display: inline-block;
      color: #fff;
      font-size: 20px;
      right: 87px;
      top: 19px;
      cursor: pointer;
    }
    .help-center {
      color: #fff;
      position: absolute;
      right: 126px;
      top: 20px;
      font-size: 21px;
      cursor: pointer;
      transition: all 0.2s;
      &:hover {
        color: #009688;
      }
    }
    .inform-view {
      background: url(../assets/image/inform.png) no-repeat;
      background-size: contain;
      width: 23px;
      height: 23px;
      position: absolute;
      right: 160px;
      top: 19px;
      z-index: 999999;
      cursor: pointer;
      transition: all 0.1s;
      &:hover {
        background: url(../assets/image/inform_hover.png) no-repeat;
        background-size: contain;
      }
      .inform-ing {
        width: 8px;
        height: 8px;
        background-color: red;
        border-radius: 50%;
        right: 1px;
        top: -3px;
        position: absolute;
        z-index: 999999;
      }
    }
    .message-box {
      width: 360px;
      height: 439px;
      background-color: #fff;
      border: 1px solid #ebebeb;
      position: absolute;
      right: 25px;
      top: 54px;
      border-radius: 5px;
      box-shadow: 0 5px 20px rgba(26, 26, 26, 0.1);
      &:before {
        position: absolute;
        content: "";
        width: 0;
        height: 0;
        top: -21px;
        left: 204px;
        border: 10px solid #000;
        border-right: 10px solid transparent;
        border-top: 10px solid transparent;
        border-left: 10px solid transparent;
      }
      &:after {
        position: absolute;
        content: "";
        width: 0;
        height: 0;
        top: -15px;
        left: 207px;
        border: 8px solid #fff;
        border-right: 8px solid transparent;
        border-top: 8px solid transparent;
        border-left: 8px solid transparent;
      }
      .message-box-top {
        border-bottom: 1px solid #ebebeb;
        width: 100%;
        height: 44px;
        color: #8590a6;
        display: flex;
        justify-content: center;
        font-size: 16px;
        align-items: center;
        position: relative;
        .close-icon {
          position: absolute;
          right: 10px;
          top: 5px;
          font-size: 21px;
          cursor: pointer;
          &:hover {
            color: red;
          }
        }
      }
      .message-box-list {
        height: 349px;
        box-sizing: border-box;
        padding: 0 15px;
        width: 100%;
        overflow-y: auto;
        &::-webkit-scrollbar {
          /*使滚动条变窄*/
          width: 1px;
        }
        .message-box-list-item {
          height: 45px;
          border-bottom: 1px dashed #ebebeb;
          display: flex;
          align-items: center;
          position: relative;
          .msglist-img {
            width: 20px;
            height: 20px;
            img {
              width: 100%;
            }
          }
          .msglist-title {
            font-size: 14px;
            color: #1a1a1a;
            font-weight: bold;
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
          .msglist-title-readed {
            font-size: 14px;
            color: #9ba4b6;
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
          .msglist-time {
            color: #ccc;
            position: absolute;
            right: 0;
          }
        }
        .read-more {
          height: 40px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 14px;
          color: #8590a6;
          transition: all 0.2s;
          &:hover {
            color: #009688;
          }
          .el-loading-spinner {
            top: 0;
            margin-top: 7px;
          }
        }
        .no-more-msg {
          width: 100%;
          height: 45px;
          line-height: 45px;
          font-size: 14px;
          color: #909399;
          text-align: center;
        }
      }
      .message-box-bottom {
        height: 44px;
        width: 100%;
        border-top: 1px solid #ebebeb;
        position: relative;
        .message-box-sendmsg {
          color: #8590a6;
          font-size: 14px;
          position: absolute;
          left: 20px;
          top: 13px;
          cursor: pointer;
          transition: all 0.2s;
          &:hover {
            color: #9ba4b6;
          }
        }
        .message-box-deletemsg {
          color: #8590a6;
          font-size: 14px;
          position: absolute;
          left: 70px;
          top: 13px;
          cursor: pointer;
          transition: all 0.2s;
          &:hover {
            color: #ff8080;
          }
        }
        .mark-readed {
          color: #8590a6;
          font-size: 14px;
          position: absolute;
          left: 135px;
          top: 13px;
          cursor: pointer;
          transition: all 0.2s;
          &:hover {
            color: #ff8080;
          }
        }
        .message-box-close {
          color: #8590a6;
          font-size: 14px;
          position: absolute;
          right: 20px;
          top: 13px;
          cursor: pointer;
          transition: all 0.2s;
          &:hover {
            color: #9ba4b6;
          }
        }
      }
    }
    .help-center-box {
      width: 300px;
      // height: 300px;
      padding-bottom: 20px;
      background-color: #fff;
      border: 1px solid #ebebeb;
      position: absolute;
      right: 51px;
      top: 54px;
      z-index: 9999999;
      border-radius: 5px;
      box-shadow: 0 5px 20px rgba(26, 26, 26, 0.1);
      &:before {
        position: absolute;
        content: "";
        width: 0;
        height: 0;
        top: -21px;
        left: 204px;
        border: 10px solid #000;
        border-right: 10px solid transparent;
        border-top: 10px solid transparent;
        border-left: 10px solid transparent;
      }
      &:after {
        position: absolute;
        content: "";
        width: 0;
        height: 0;
        top: -15px;
        left: 207px;
        border: 8px solid #fff;
        border-right: 8px solid transparent;
        border-top: 8px solid transparent;
        border-left: 8px solid transparent;
      }
      .help-center-item {
        height: 40px;
        border-bottom: 1px dashed #ebebeb;
        display: flex;
        align-items: center;
        padding-left: 20px;
        font-size: 14px;
        color: #1a1a1a;
        a {
          &:hover {
            text-decoration: underline;
          }
        }
      }
      .help-title {
        height: 30px;
        position: relative;
        margin-top: 10px;
        width: 100%;
        display: flex;
        font-size: 16px;
        font-weight: bold;
        justify-content: center;
        align-items: center;
        color: #909399;
        .close-icon {
          position: absolute;
          right: 10px;
          top: -4px;
          cursor: pointer;
          font-size: 18px;
          &:hover {
            color: red;
          }
        }
      }
      .version-view {
        color: #909399;
        font-size: 14px;
        width: 100%;
        box-sizing: border-box;
        margin-top: 14px;
        text-align: right;
        padding-right: 14px;
      }
    }
    .send-message-box {
      width: 550px;
      min-height: 420px;
      padding: 20px;
      background-color: #fff;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 50px;
      border-radius: 5px;
      z-index: 999999;
      box-shadow: 0 5px 20px rgba(26, 26, 26, 0.1);
      .close {
        width: 20px;
        height: 20px;
        position: absolute;
        right: 12px;
        top: 7px;
        background: url(../assets/image/close.png) no-repeat;
        background-size: contain;
        transition: all 0.2s;
        cursor: pointer;
        &:hover {
          background: url(../assets/image/close_hover.png) no-repeat;
          background-size: contain;
        }
      }
      .select-module {
        width: 100%;
        margin-top: 10px;
        .select-des {
          color: #9ba4b6;
          font-size: 15px;
          margin-bottom: 10px;
          padding-left: 2px;
          i {
            font-style: normal;
            font-size: 14px;
            color: #ff0000;
          }
        }
        .select-item {
          width: 32%;
        }
      }
      .send-msg-item {
        display: flex;
        margin-top: 10px;
        align-items: center;
        height: 50px;
        .send-msg-des {
          font-size: 15px;
          width: 80px;
          text-align: right;
          box-sizing: border-box;
          padding-right: 5px;
          color: #9ba4b6;
        }
        .send-msg-option {
          width: 300px;
        }
      }
      .send-content-des {
        font-size: 15px;
        width: 80px;
        text-align: right;
        box-sizing: border-box;
        padding-right: 5px;
        color: #9ba4b6;
        margin-top: 15px;
      }
      .send-content {
        margin-top: 10px;
      }
      .send-msg-btn {
        width: 80px;
        margin-left: 420px;
        margin-top: 10px;
      }
    }
    .watch-message-box {
      width: 500px;
      min-height: 250px;
      background-color: #fff;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 50px;
      border-radius: 5px;
      z-index: 999999;
      padding: 20px;
      box-shadow: 0 5px 20px rgba(26, 26, 26, 0.1);
      .close {
        width: 20px;
        height: 20px;
        position: absolute;
        right: 12px;
        top: 7px;
        background: url(../assets/image/close.png) no-repeat;
        background-size: contain;
        transition: all 0.2s;
        cursor: pointer;
        &:hover {
          background: url(../assets/image/close_hover.png) no-repeat;
          background-size: contain;
        }
      }
      .send-msg-title {
        font-size: 24px;
        font-weight: bold;
        width: 100%;
        text-align: center;
        margin-bottom: 10px;
        color: #909399;
      }
      .send-user {
        font-size: 15px;
        color: #8590a6;
        i {
          font-style: normal;
          color: #838383;
        }
      }
      .send-time {
        font-size: 15px;
        color: #8590a6;
        margin-top: 20px;
        i {
          font-style: normal;
          color: #838383;
        }
      }
      .send-msg-view {
        .send-msg-des {
          font-size: 15px;
          color: #8590a6;
          margin-top: 20px;
        }
        .send-msg-content {
          font-size: 15px;
          color: #838383;
          text-indent: 2em;
          margin-top: 10px;
          min-height: 100px;
          border: 1px solid #ebebeb;
          border-radius: 5px;
          box-sizing: border-box;
          padding: 5px;
        }
      }
      .operate-view {
        margin-top: 20px;
        .delete-btn {
          margin-left: 440px;
        }
      }
    }
  }
  /*滚动条样式*/
  ::-webkit-scrollbar {
    width: 0;
  }
  .left-side {
    position: fixed;
    // width: 220px;
    height: 100%;
    background-color: #545c64;
    box-sizing: border-box;
    padding-top: 60px;
    overflow: hidden;
    overflow-y: auto;
    z-index: 888;
    .el-menu {
      border-right: none;
    }
    .ii .el-menu-item-group__title {
      padding-top: 0px !important;
      padding-bottom: 0px !important;
    }
    .ii.el-submenu {
      width: 220px;
    }
    div.el-menu-item-group__title {
      padding: 0 !important;
    }
    .bb {
      width: 220px;
      height: 56px;
      cursor: pointer;
      background-color: rgb(84, 92, 100);
      transition: all 0.2s;
      padding-left: 18px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      &:hover {
        background-color: rgb(67, 74, 80);
      }
      i {
        font-size: 28px;
        color: #909399;
        margin-top: 3px;
      }
      a {
        color: rgb(248, 248, 249);
        font-size: 14px;
        padding-left: 9px;
        display: inline-block;
        height: 56px;
        display: flex;
        align-items: center;
        width: 166px;
      }
    }
    .el-submenu .el-menu-item:focus,
    .el-submenu .el-menu-item:hover {
      background: rgb(67, 74, 80);
    }
  }
}
.el-menu--vertical {
  left: 70px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/base.vue